import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import Actions from '../action';
import SalesForcePresentational from './salesForcePresentational';
import Selectors from '../selectors';
import { connect } from 'react-redux';

const SalesForceFunctional = ({ getOpportunityInfoStart, isOpportunityLoading, opportunityData, getTokenAction, tokenSuccess, tokenData }) => {
	const history = useHistory();
	const { optId } = useParams();
	useEffect(() => {
		if (!localStorage.getItem('token')) {
			// getTokenAction();
		}
	}, []);

	useEffect(() => {
		if (!localStorage.getItem('token') && tokenData) {
			localStorage.setItem('token', tokenData.access_token);
		}
		if (tokenData || localStorage.getItem('token')) {
			getOpportunityInfoStart(history, optId);
		}
		getOpportunityInfoStart(history, optId);
	}, [tokenData]);

	return (
		<>
			<SalesForcePresentational
				getOpportunityInfoStart={getOpportunityInfoStart}
				isOpportunityLoading={isOpportunityLoading}
				opportunityData={opportunityData}></SalesForcePresentational>
		</>
	);
};
const mapStateToProps = (state) => {
	return {
		isOpportunityLoading: Selectors.isOpportunityLoading(state),
		opportunityData: Selectors.opportunityData(state),
		tokenSuccess: Selectors.tokenSuccess(state),
		tokenData: Selectors.tokenData(state),
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		getOpportunityInfoStart: (history, optId, isLandingPageClick) =>
			dispatch(Actions.creators.getOpportunityInfoStart(history, optId, isLandingPageClick)),
		getTokenAction: () => dispatch(Actions.creators.getTokenAction()),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(SalesForceFunctional);
export default Connected;
